import { Cloud } from "lucide-react";
import type { FpMessagePart } from "../../../../../schemas/codegen";
import { SimpleMessageCard } from "./shared";

interface DeployProps {
  part: Extract<FpMessagePart, { type: "tool-call" }>;
  messageId: string;
}

export function Deploy({ part }: DeployProps) {
  return (
    <SimpleMessageCard
      status={part.status}
      icon={Cloud}
      title="Legacy deploy"
    />
  );
}
